
var HorizontalFlip = {
    uniforms: {
        "tDiffuse": { value: null },
    },

    vertexShader: `
        varying vec2 vUv;

        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader:`
        uniform sampler2D tDiffuse;
        uniform float colorFactor;
        varying vec2 vUv;

        void main() {
            vec2 coords = vec2(1.0 - vUv.x, vUv.y);
            vec4 texel = texture2D(tDiffuse, coords);
            gl_FragColor = texel.rgba;
        }
    `,

};

export { HorizontalFlip };
